// import React, { useEffect, useRef, useState } from "react";
// import { CameraPopupProps } from "../interface/camera";

// const CameraPopup: React.FC<CameraPopupProps> = ({ stream }) => {
//   const videoRef = useRef<HTMLVideoElement>(null);
//   const popupRef = useRef<HTMLDivElement>(null);

//   const dragging = useRef(false);
//   const dragOffset = useRef({ x: 0, y: 0 });

//   const [minimized, setMinimized] = useState(false);

//   const [pos, setPos] = useState({
//     x: window.innerWidth - 260,
//     y: window.innerHeight - 220,
//   });

//   // -----------------------------
//   // Attach stream to video
//   // -----------------------------
//   useEffect(() => {
//     const video = videoRef.current;
//     if (!video || !stream) return;

//     video.srcObject = stream;

//     video.play().catch(() => {});

//     return () => {
//       video.srcObject = null;
//     };
//   }, [stream]);

//   // -----------------------------
//   // Drag start
//   // -----------------------------
//   const onMouseDown = (e: React.MouseEvent) => {
//     dragging.current = true;

//     const rect = popupRef.current?.getBoundingClientRect();
//     if (!rect) return;

//     dragOffset.current = {
//       x: e.clientX - rect.left,
//       y: e.clientY - rect.top,
//     };

//     e.preventDefault();
//   };

//   // -----------------------------
//   // Drag move
//   // -----------------------------
//   useEffect(() => {
//     const onMouseMove = (e: MouseEvent) => {
//       if (!dragging.current) return;

//       const popupWidth = 240;
//       const popupHeight = minimized ? 60 : 200;

//       const maxX = window.innerWidth - popupWidth;
//       const maxY = window.innerHeight - popupHeight;

//       const newX = e.clientX - dragOffset.current.x;
//       const newY = e.clientY - dragOffset.current.y;

//       setPos({
//         x: Math.max(0, Math.min(newX, maxX)),
//         y: Math.max(0, Math.min(newY, maxY)),
//       });
//     };

//     const onMouseUp = () => {
//       dragging.current = false;
//     };

//     window.addEventListener("mousemove", onMouseMove);
//     window.addEventListener("mouseup", onMouseUp);

//     return () => {
//       window.removeEventListener("mousemove", onMouseMove);
//       window.removeEventListener("mouseup", onMouseUp);
//     };
//   }, [minimized]);

//   // -----------------------------
//   // Don't render if no stream
//   // -----------------------------

//   if (!stream) return null;

//   return (
//     <div
//       ref={popupRef}
//       style={{
//         position: "fixed", // 🔥 CRITICAL FIX
//         left: pos.x,
//         top: pos.y,
//         width: "240px",
//         background: "#fff",
//         borderRadius: "12px",
//         boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
//         zIndex: 999999, // 🔥 always on top
//         overflow: "hidden",
//         userSelect: "none",
//       }}
//     >
//       {/* ---------------- HEADER ---------------- */}
//       <div
//         onMouseDown={onMouseDown}
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           padding: "8px 10px",
//           background: "#111",
//           color: "#fff",
//           cursor: "grab",
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//           <span
//             style={{
//               width: 8,
//               height: 8,
//               background: "red",
//               borderRadius: "50%",
//               display: "inline-block",
//             }}
//           />
//           <span style={{ fontSize: 12 }}>LIVE</span>
//           <span style={{ fontSize: 12, marginLeft: 6 }}>Camera</span>
//         </div>

//         <button
//           onClick={() => setMinimized((m) => !m)}
//           style={{
//             background: "transparent",
//             border: "none",
//             color: "#fff",
//             cursor: "pointer",
//             fontSize: 14,
//           }}
//         >
//           {minimized ? "▲" : "▼"}
//         </button>
//       </div>

//       {/* ---------------- BODY ---------------- */}
//       <div
//         style={{
//           width: "100%",
//           background: "#000",
//           display: minimized ? "none" : "block", // ✅ hide instead of unmount
//         }}
//       >
//         <video
//           ref={videoRef}
//           autoPlay
//           playsInline
//           muted
//           style={{
//             width: "100%",
//             height: "160px",
//             objectFit: "cover",
//             display: "block",
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default CameraPopup;
import React, { useEffect, useRef, useState } from "react";
import { CameraPopupProps } from "../interface/camera";

const CameraPopup: React.FC<CameraPopupProps> = ({ stream }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  const dragging = useRef(false);
  const dragOffset = useRef({ x: 0, y: 0 });

  const [minimized, setMinimized] = useState(false);

  const [pos, setPos] = useState({
    x: window.innerWidth - 260,
    y: window.innerHeight - 220,
  });

  // -----------------------------
  // Attach stream to video
  // -----------------------------
  useEffect(() => {
    const video = videoRef.current;
    if (!video || !stream) return;

    video.srcObject = stream;

    video.play().catch(() => {});

    return () => {
      video.srcObject = null;
    };
  }, [stream]);

  // -----------------------------
  // Drag start
  // -----------------------------
  const onMouseDown = (e: React.MouseEvent) => {
    dragging.current = true;

    const rect = popupRef.current?.getBoundingClientRect();
    if (!rect) return;

    dragOffset.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };

    e.preventDefault();
  };

  // -----------------------------
  // Drag move
  // -----------------------------
  useEffect(() => {
    const onMouseMove = (e: MouseEvent) => {
      if (!dragging.current) return;

      const popupWidth = 240;
      const popupHeight = minimized ? 60 : 200;

      const maxX = window.innerWidth - popupWidth;
      const maxY = window.innerHeight - popupHeight;

      const newX = e.clientX - dragOffset.current.x;
      const newY = e.clientY - dragOffset.current.y;

      setPos({
        x: Math.max(0, Math.min(newX, maxX)),
        y: Math.max(0, Math.min(newY, maxY)),
      });
    };

    const onMouseUp = () => {
      dragging.current = false;
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [minimized]);

  // -----------------------------
  // Don't render if no stream
  // -----------------------------

  if (!stream) return null;

  return (
    <div
      style={{
        width: "180px",
        height: "100px",
        background: "#fff",
        borderRadius: "30px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
        overflow: "hidden",
        userSelect: "none",
      }}
    >
      {/* ---------------- BODY ---------------- */}
      <div
        style={{
          width: "100%",
          background: "#000",
          display: minimized ? "none" : "block", // ✅ hide instead of unmount
        }}
      >
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </div>
    </div>
  );
};

export default CameraPopup;
